module.exports = __webpack_public_path__ + "img/Taco-Carnitas.40dc4f38.jpg";